module.exports = __webpack_public_path__ + "images/activitiesMsg.9328a54.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/activities/activitiesMsg.png
// module id = 226
// module chunks = 0